import { DishType, ItemTypeFilter, MissingFilter, ServiceFilter, StatusFilter } from './types'

// Single source of truth for filter option value→label pairs. Both the filter
// bar (dropdown options) and the active-filter chips (label lookup) derive from
// these, so a new value is added in exactly one place.

export type Option<T extends string> = { value: T; label: string }

export const SERVICE_OPTIONS: Option<ServiceFilter>[] = [
  { value: 'gm', label: 'Catering' },
  { value: 'cc', label: 'Cloud Canteen' },
]

export const STATUS_OPTIONS: Option<StatusFilter>[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'private', label: 'Private Item' },
]

export const ITEM_TYPE_OPTIONS: Option<ItemTypeFilter>[] = [
  { value: 'main', label: 'Main' },
  { value: 'side', label: 'Side' },
  { value: 'drink', label: 'Drink' },
]

export const DISH_TYPE_OPTIONS: Option<DishType>[] = [
  { value: 'items', label: 'Menu Item' },
  { value: 'addons', label: 'Add on' },
]

// Labels match the Menu Overview "What's missing?" chart bars, which deep-link
// here — the chip must read as the bar the admin clicked.
export const MISSING_OPTIONS: Option<MissingFilter>[] = [
  { value: 'nutritional', label: 'Nutritional' },
  { value: 'foodGoals', label: 'Dietaries and Food Goals' },
  { value: 'images', label: 'Images' },
]

// Look up a single value's label within an option list (falls back to the raw
// value if not found).
export const labelFor = <T extends string>(options: Option<T>[], value: T): string =>
  options.find((o) => o.value === value)?.label ?? value
